import { Fragment, useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MenuItem from "@material-ui/core/MenuItem";
import Divider from "@material-ui/core/Divider";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

const KeyPosVisited = ({
  keyPosInfo,
  handleChildPosChange,
  handleDigitalCoverageChange,
  error,
  readOnly,
}) => {
  const { t } = useTranslation();
  const state = useSelector((state) => state.keyPos);
  const commonState = useSelector((state) => state.common);
  const [editableFields, setEditableFields] = useState({});
  const [controls, setControls] = useState([]);
  const [restrictedFields, setRestrictedFields] = useState({});

  const childPosData = [
    {
      listId: "kaChain",
      label: "KA Chain",
      field: "KAChainDescription",
      key: "KAChainDescription",
      sk: "KAChainSK",
    },
    {
      listId: "customerType",
      label: "Customer Type",
      field: "KAChainCustTypeDesc",
      key: "KAChainCustTypeDesc",
      sk: "KAChainCustTypeDesc",
    },
    {
      listId: "channel",
      label: "Channel Code",
      field: "KeyPOSChannelDescription",
      key: "KeyPOSChannelDescription",
      sk: "KeyPOSChannelSK",
    },

    {
      listId: "location",
      label: "Location",
      field: "KeyPOSLocationDescription",
      key: "KeyPOSLocationDescription",
      sk: "KeyPOSLocationSK",
    },

    {
      listId: "kaOwner",
      label: "KA Owner",
      field: "KeyPOSKAOwnerDescription",
      key: "KeyPOSKAOwnerDescription",
      sk: "KeyPOSKAOwnerSK",
    },
    {
      listId: "kaAgreement",
      label: "KA Agreement",
      field: "KeyPOSKAAgreementDescription",
      key: "KeyPOSKAAgreementDescription",
      sk: "KeyPOSKAAgreementSK",
    },
    {
      listId: "cigarCase",
      label: "Cigar Case",
      field: "KeyPOSCigarCaseDescription",
      key: "KeyPOSCigarCaseDescription",
      sk: "KeyPOSCigarCaseSK",
    },
    {
      listId: "cigarType",
      label: "Ciagar Type",
      field: "KeyPOSCigarTypeDescription",
      key: "KeyPOSCigarTypeDescription",
      sk: "KeyPOSCigarTypeSK",
    },
    {
      listId: "quantityofModules",
      label: "Quantity of Modules",
      field: "KeyPOSQuantityOfModulesDescription",
      key: "KeyPOSQuantityOfModulesDescription",
      sk: "KeyPOSQuantityOfModulesSK",
    },
    {
      listId: "secondaryMaterial",
      label: "Secondary Material",
      field: "KeyPOSSecondaryMaterialCodeDescription",
      key: "KeyPOSSecondaryMaterialCodeDescription",
      sk: "KeyPOSSecondaryMaterialCodeSK",
    },
  ];

  const getControls = () => {
    const roles = ["PMIARURPOSISKAExecutive_IMDL", "PMIARURPOSISWebAdminUser_IMDL", "PMIARURPOSISITSupport_IMDL"];
    const userRoles = commonState?.userInfo?.userGroups;
    // const userRoles = ['PMIARURPOSISWebPROFILEMerchandiserUser_IMDL'];
    const hasAccess = userRoles.some(role => roles.includes(role.trim()));
    const fieldControls = state?.fieldControls?.slice();
    const resFields = {}
    const results = fieldControls.map(elem => {
      if (elem.targetField === "kaAgreement" && !hasAccess) {
        elem.editable = "0";
        resFields[elem.targetField] = true;
      }
      return elem;
    });
    setRestrictedFields(resFields);
    console.log("getControls => New controls", results);
    return results;
  }

  const handleKeyposChange = (event, value, key, sk, listId) => {
    handleChildPosChange(event, value, key, sk);
    const fields = {};
    console.log(value, key, sk, listId);
    if (key === "KAChainDescription") {
      listId = "customerType";
    }
    const find = controls.filter((map) => map.sourceField === listId && (map.value === value?.ParamDescriptionEN || map.value === null || map.value === ""));
    console.log("Found controls => ", find);
    if (Array.isArray(find) && find.length > 0) {
      find.forEach(el => {
        if (el.editable === "0") {
          fields[el.targetField] = true;
          const targetInfo = childPosData.find(elem => elem.listId === el.targetField);
          if (targetInfo?.key) {
            handleChildPosChange(event, null, targetInfo.key, targetInfo.sk);
          }
        } else {
          fields[el.targetField] = false;
        }
      });
    }
    setEditableFields({ ...fields, ...restrictedFields });
    console.log("Found controls => handleKeyposChange => ", editableFields, fields);
  }

  useEffect(() => {
    const fields = {};
    childPosData.forEach(posData => {
      const find = controls.filter((map) => map.sourceField === posData.listId && 
                                                        map.value === state?.keyPosEdit[posData.field]);
      if (Array.isArray(find) && find.length > 0) {
        find.forEach(el => {
          if (el.editable === "0")
            fields[el.targetField] = true;
          else
            fields[el.targetField] = false;
        });
      }
    });
    console.log("Found controls => useeffect => ", editableFields, fields);
    setEditableFields({ ...fields, ...restrictedFields });
  }, [controls, state.keyPosEdit, restrictedFields]);

  useEffect(() => {
    setControls(getControls());
  }, [state?.fieldControls])

  return (
    <Fragment>
      <Grid item sm={12}>
        <Divider />
      </Grid>
      <Grid container style={{ padding: "1rem" }} spacing={3}>
        <Grid item sm={6} lg={4} xs={12}>
          <TextField
            variant="outlined"
            size="small"
            style={{ maxWidth: 250 }}
            select
            fullWidth
            // style={{ minWidth: 245 }}
            value={keyPosInfo?.KeyPOSHotZone || 0}
            name="KeyPOSHotZone"
            onChange={(event, value) =>
              handleChildPosChange(event, value, "KeyPOSHotZone")
            }
            label={t(`Hot Zone`)}
            disabled={readOnly}
          >
            <MenuItem value={1}>Yes</MenuItem>
            <MenuItem value={0}>No</MenuItem>
          </TextField>
        </Grid>

        <Grid item sm={6} lg={4} xs={12}>
          <TextField
            select
            variant="outlined"
            style={{ maxWidth: 250 }}
            fullWidth
            value={keyPosInfo?.KeyPOSDigitalCoverage || ""}
            name="KeyPOSDigitalCoverage"
            onChange={handleDigitalCoverageChange}
            label={t(`Digital Coverage`)}
            size="small"
            InputLabelProps={{ shrink: true }}
            disabled={readOnly}
          >
            <MenuItem value="Y">Yes</MenuItem>
            <MenuItem value="N">No</MenuItem>
          </TextField>
        </Grid>
      </Grid>

      {childPosData.map(({ listId, label, field, key, sk }) => {
        return (
          <Grid item sm={6} lg={4} xs={12} key={listId}>
            {listId === "customerType" ? (
              <TextField
                size="small"
                className="customer_input"
                value={keyPosInfo?.KAChainCustTypeDesc || ""}
                disabled
                name={key}
                InputLabelProps={{ shrink: true }}
                label={t(label)}
                variant="outlined"
              />
            ) : (
              <Autocomplete
                name={listId}
                value={keyPosInfo}
                onChange={(event, value) =>
                  handleKeyposChange(event, value, key, sk, listId)
                }
                options={keyPosInfo[`${listId}`] || []}
                getOptionLabel={(option) => option[field] || ""}
                renderOption={(option) => <span>{option[field]}</span>}
                disabled={readOnly || editableFields[listId]}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    style={{ maxWidth: 250 }}
                    InputLabelProps={{ shrink: true }}
                    label={t(label)}
                    variant="outlined"
                    error={error[key] ? true : false}
                    helperText={error[key]}
                  />
                )}
              />
            )}
          </Grid>
        );
      })}
    </Fragment>
  );
};

export default KeyPosVisited;

KeyPosVisited.propTypes = {
  keyPosInfo: PropTypes.object,
  handleChildPosChange: PropTypes.func,
  handleDigitalCoverageChange: PropTypes.func,
  error: PropTypes.object,
  readOnly: PropTypes.bool,
};
